<div class="yaml-container">
  <pre class="language-yaml"><code [innerHTML]="yamlHtml"></code></pre>
</div>